export default {
  methods: {
    sleep: function (time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    request: function (method, path, data) {
      return new Promise((resolve, reject) => {
        switch (method.toLowerCase()) {
          case 'get':
            window.axios.get(path)
              .then((response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
          case 'post':
            window.axios.post(path, data)
              .then((response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
          case 'put':
            window.axios.put(path, data)
              .then(async (response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
          case 'delete':
            window.axios.delete(path, data)
              .then((response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
        }
      });
    },
  },
}
